import { styled } from "styled-components";

export const HomeContainer = styled.div`
  display: flex;
  background-color: #e5e7eb;
  border-radius: 15px;
  margin: 10px 5px;
`;
